import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { LocalService, StatusWithId, KeyValues5, KeyValues3, KeyValues10, KeyValueSets, KeyValues15, QrLabelTemplateType, KeyValueSet, Paging, Wrappers10, ActiveInactiveFor, KeyValues30 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  private controllerName = service_controllers_methods.report.controller;
  private methods = service_controllers_methods.report.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public setSaleSettlement(businessId: string, isFinalSettlement: boolean): Observable<StatusWithId> {
    var body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: isFinalSettlement ? '1' : '0' } as KeyValues5
    };

    return this.httpService.request_general_post(this.controllerName + this.methods.SetSaleSettlement, body);
  }

  public getSaleSettlements(businessId: string, paging: Paging): Observable<Wrappers10> {
    var body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues5,
      pag: paging
    };

    return this.httpService.request_general_post(this.controllerName + this.methods.GetSaleSettlements, body);
  }
}
